import { useMemo, useReducer } from "react";
import { useOrg } from "src/hooks/useOrg";
import { SearchState } from "../types";
import { useParamsStateSelectors } from "./useParamsStateSelectors";
import { useParamsStateModifiers } from "./useParamsStateModifiers";
import {
  createStateReducer,
  ensureState,
  serializeParams,
} from "./params-state-reducer";

export type SerializedParams = string;

export function useInputParams(
  initial: SearchState,
  ...base: Parameters<typeof createStateReducer>
) {
  const orgId = useOrg().id;

  const reducer = createStateReducer(...base);
  const baser = base && base[0] ? base[0] : (x: typeof initial) => x;
  const based = ensureState(baser(initial), orgId);
  const [state, dispatch] = useReducer(reducer, based);

  // This serialized value is used for hooks that depend on state changes.
  // Just watch this value, then unserialize it (or keep a ref).
  // The deep nature of the params state won't matter when done right.
  const serialized: SerializedParams = useMemo(
    () => serializeParams(state),
    [state]
  );
  const modifiers = useParamsStateModifiers();
  const selectors = useParamsStateSelectors();
  return { dispatch, modifiers, selectors, serialized, state };
}
